import React from 'react'
import Navbar from './Navbar'
import Footer from './Footer'

const Contact = () => {
  return (
    <div>
        <Navbar/>
        <div className='lop'>
        <p>You can reach out to us at : +1(888)377-7633. </p>
        </div>
        <Footer/>
    </div>
  )
}

export default Contact